import React from 'react';
import './ProductItem.css';

function ProductItem({ product, isSelected, onSelect }) {
  return (
    <div 
      className={`product-item ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      <div className="product-details">
      <p className="product-name">{product.offer.length > 30 && "..."}{product.offer.slice(0, 30)}</p>
        <p className="product-picto">{product.productName}</p>
      </div>

      <div className="product-details">
        <p className="product-price">{product.finalPrice} MAD</p>
        <p className="product-validity">{product.validity} days</p>
      </div>
      {isSelected && (
        <div className="selected-indicator">✓</div>
      )}
    </div>
  );
}

export default ProductItem;